<template>
  <div>
    {{unidades}}
    <LineChartGenerator
    :chart-options="chartOptionsMutado"
    :chart-data="chartData"
  />
  </div>
 
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import {mapState} from 'vuex'


import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(  
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  zoomPlugin,
  annotationPlugin,
  CategoryScale)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    unidades:String,
    chartData: {
      labels:Array,
      datasets: Array,
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    kk(v){
      return `kk ${v}`
    }
  },
  computed: {
    // ...mapState([
    //     'higienizacion1',
    //     'higienizacion2',
    // ]),
    chartOptionsMutado(){
      let k={
        plugins: {
          title: {
            display: true,
            // text: this.title,
            font: {
              size: 18
            }
          },
          annotation: {
              annotations: {
                line1: {
                  type: 'line',
                  yMin: parseFloat(this.chartData.consigna),
                  yMax: parseFloat(this.chartData.consigna),
                  borderColor: 'rgb(255, 99, 132)',
                  borderWidth: 2,
                }
              //   line2: {
              //     type: 'line',
              //     yMin: parseFloat(this.higienizacion2.temperaturaUmbral),
              //     yMax: parseFloat(this.higienizacion2.temperaturaUmbral),
              //     borderColor: 'rgb(255, 99, 132)',
              //     borderWidth: 2,
              //   }
              }
            },
          
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
              pan: {
                enabled: true
              },
              drag: {
                enabled: true
              }
            }
          }
        },
         animation: {
            duration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                ticks: {
                  stepSize: 1,
                    callback: function(value, index) {
                     
                        return value.toFixed(0)
                    }
                },
                suggestedMin: this.chartData.consigna?this.chartData.consigna-30:0,
                suggestedMax: this.chartData.consigna?this.chartData.consigna+30:0
            }
        }
      } 
      return k
    }
  },

  data() {

    return {
     
      chartOptions: {
        
        animation: {
            duration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                ticks: {
                  stepSize: 20,
                    callback: function(value, index) {
                        return `${value} ºC`;
                    }
                },
                suggestedMin: 0,
                suggestedMax: 100
            }
        }
      }
    }
  }
}
</script>